/**
 * Gemeinsame Definition dessen, was als fokussierbar gilt.
 *
 * Vorher hatte jede Komponente mit Fokus-Handling ihre eigene, leicht
 * abweichende Liste (Mobile-Menü ohne input/select/textarea, Mega-Nav ohne
 * select/textarea). Damit eine Verbesserung hier künftig überall greift,
 * liegt die Liste an einer Stelle.
 */
export const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Alle fokussierbaren Elemente innerhalb von container, in DOM-Reihenfolge.
 * Gibt bei fehlendem container eine leere Liste zurück, damit Aufrufer nicht
 * zusätzlich auf null prüfen müssen.
 */
export function getFocusableElements(container: HTMLElement | null): HTMLElement[] {
    if (!container) {
        return [];
    }

    return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
}
